import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { InputField, LoaderButton } from 'components/molecules'
import * as Yup from 'yup'

const propTypes = {
  onSubmit: PropTypes.func.isRequired
}

const salesReconcileSchema = Yup.object().shape({
  orders_date_from : Yup.date().required('Required'),
  orders_date_to   : Yup.date().required('Required')
})

/**
 * Form to input date-range before downloading finance orders csv
 * @param {Function} onSubmit - function to submit form
 */
const BankTransactionOrdersDownloadForm = ({ onSubmit }) => (
  <Formik
    initialValues={{
      orders_date_from : '',
      orders_date_to   : ''
    }}
    validationSchema={ salesReconcileSchema }
    onSubmit={ onSubmit }
  >
    {
      (formikBag) => (
        <Form>
          <InputField
            type='date'
            label={ 'Orders From' }
            name={ 'orders_date_from' }
            labelClassName='small text-gray-light text-capitalize'
          />
          <InputField
            type='date'
            label={ 'Orders To' }
            name={ 'orders_date_to' }
            labelClassName='small text-gray-light text-capitalize'
          />

          <LoaderButton
            color='primary'
            type='submit'
            disabled={ formikBag.isSubmitting }
            isLoading={ formikBag.isSubmitting }
            text='Submit'
          />
        </Form>
      )
    }
  </Formik>
)

BankTransactionOrdersDownloadForm.propTypes = propTypes

export default BankTransactionOrdersDownloadForm